import api from './baseApi';

export function getTenants() {
  return api.get('/tenants/client');
}

export const getAllAvailableTenants = () => api.get('/tenants/client/all'); // This includes the Guid of the tenant, not just the name
